export function formateDate(date) {
  if (date) {
    let dateArray = date.split('-')
    let suffix = dateArray[2] + ', ' + dateArray[0]
    let month = dateArray[1]
    if (month === '01') {
      return 'Jan ' + suffix
    } else if (month === '02') {
      return 'Feb ' + suffix
    } else if (month === '03') {
      return 'Mar ' + suffix
    } else if (month === '04') {
      return 'Apr ' + suffix
    } else if (month === '05') {
      return 'May ' + suffix
    } else if (month === '06') {
      return 'Jun ' + suffix
    } else if (month === '07') {
      return 'Jul ' + suffix
    } else if (month === '08') {
      return 'Aug ' + suffix
    } else if (month === '09') {
      return 'Sep ' + suffix
    } else if (month === '10') {
      return 'Oct ' + suffix
    } else if (month === '11') {
      return 'Nov ' + suffix
    } else if (month === '12') {
      return 'Dec ' + suffix
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/formateEnDate.js